import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  title: {
    id: 'components.CardLumaBotFlow.components.DeleteDialog.title',
    defaultMessage: 'Flow Session log',
  },
  close: {
    id: 'components.CardLumaBotFlow.components.DeleteDialog.close',
    defaultMessage: 'Close',
  },
});
